import { plainToInstance, Transform, Type } from 'class-transformer'
import i18n from 'vue-i18n'

import { PropertyFieldType } from '../../../../../../../BotProperties/components/Properties/types'
import { MenuSectionNames } from '../../../../../components'
import { BaseNodeModelData } from '../../../BaseNode/BaseNodeDataModel'
import { BaseNodeModel } from '../../../BaseNode/BaseNodeModel'
import BaseValue, { SetPropertyActionValue } from '../../../Branching/ConditionsNode/logic/PropertyConditionValues/BaseValue'
import ConstantValue
  from '../../../Branching/ConditionsNode/logic/PropertyConditionValues/ConstantValue'
import PropertyValue
  from '../../../Branching/ConditionsNode/logic/PropertyConditionValues/PropertyValue'
import { CustomNode, CustomNodeComponent, NodeTypes } from '../../../index'
import RunFlowSampleNode from '../ui/SampleNode/RunFlowSampleNode.vue'
import RunFlowSidebar from '../ui/Sidebar/RunFlowSidebar.vue'
import { RunFlowNodeProps } from './types'

export default class RunFlowNodeBuilder extends CustomNodeComponent {
  menuSection = MenuSectionNames.Additionally
  sidebarComponent = RunFlowSidebar

  constructor(i18n: i18n, nodeProps: RunFlowNodeProps) {
    super(RunFlowSampleNode, RunFlowNode, NodeTypes.RunFlow, i18n, nodeProps)
  }

  getBaseNodeModel = ([ x, y ]: [ number, number ]) => {
    return {
      data: plainToInstance(RunFlowNodeData, {
        type: NodeTypes.RunFlow,
        token: '',
        target: null,
      }),
      input: CustomNode.LastSocketId += 1,
      color: null,
      x,
      y,
    }
  }
}

export class RunFlowNode extends CustomNode {
  data: RunFlowNodeData

  declare nodeProps: RunFlowNodeProps
  constructor(name: NodeTypes.RunFlow, model: BaseNodeModel, nodeProps: RunFlowNodeProps) {
    super(name, model, nodeProps)

    if (model.data instanceof RunFlowNodeData) {
      this.data = model.data
    } else {
      throw new Error('To node come unknown data')
    }
  }

  get stringTypeProperties() {
    return this.nodeProps.properties().filter(p => p.type === PropertyFieldType.Number)
  }

  setFlow(token: string): void {
    this.data.token = token
  }

  setPropIndex(index: number) {
    if (this.data.target instanceof PropertyValue) {
      this.data.target.property_index = index
    }
  }
}

export class RunFlowNodeData extends BaseNodeModelData {
  declare type: NodeTypes.RunFlow
  token!: string

  @Transform(({ value }) => {
    if (value !== null) {
      if (value?.type === SetPropertyActionValue.Property) {
        return plainToInstance(PropertyValue, value)
      } else if (value?.type === SetPropertyActionValue.Constant) {
        return plainToInstance(ConstantValue, value)
      }
    }

    return null
  })
  target!: BaseValue | null
}
